import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: 40
  }
}));

const ErrorMessages = (props) => {
  const classes = useStyles();
  const { errors } = props;
  const { t } = useTranslation();

  function extraeApartado (error) {
    return error.property.substring(1, error.property.lastIndexOf('.'));
  }

  if (errors.length === 0) {
    return <></>;
  }

  return (
    <div className={classes.root}>
      <Alert severity='error'>
        <AlertTitle>{t('errorMsg:title')}</AlertTitle>
        {errors.map((error, key) => {
          if (error.name === 'required') {
            return (
              <div key={key}>
                {`${t('errorMsg:fillField')} ${error.params.missingProperty} ${t('errorMsg:inSection')} ${extraeApartado(error)}`}
              </div>
            );
          } else {
            return <></>;
          }
        })}
      </Alert>
    </div>
  );
};

export default ErrorMessages;
